/** CollisionShape3D registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCollisionShape3D } from './parser';
const collisionShape3DRegistration = {
    typeName: 'CollisionShape3D',
    parser: parseCollisionShape3D,
};
nodeRegistry.register(collisionShape3DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map